import { lazy, Suspense, useEffect, useState } from "react";
import "./App.css";
import { Provider } from "react-redux";
import { ToastProvider } from "fds";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import rootReducer from "./redux/dispatcher/index";
import { configureStore } from "@reduxjs/toolkit";
import ProgressParents from "./pages/Prgress/ProgressParents";
import utilsCommon from "./shared/utils/common";
import { initMSAppConfig } from "./shared/utils/msAppConfig";
import "@front/fds2.0-green/dist/index.css";
// import "fds/dist/index.css";
import BaseLayout from "./BaseLayout";
import BaseLayoutAdmin from "./BaseLayoutAdmin";
import ApiReference from "./pages/ApiReference";
import CheckSignup from "./pages/CheckSignup";
import ClientEco from "./pages/ClientEco";
import ClientDocDetailModal from "./pages/ClientEco/ClientDocDetailModal";
import ClientNone from "./pages/ClientEco/Page/ClientNone";
import DownloadClient from "./pages/DownloadClient";
import ErrorPage from "./pages/Error";
import LinkLogin from "./pages/HTMLLogin";
import Login from "./pages/Login";
import PrivacyPage from "./pages/PolicyModal/PrivacyPage";
import TermsPage from "./pages/PolicyModal/TermsPage";
import Preview from "./pages/Preview";
import Service from "./pages/Service";
import Signup from "./pages/Signup";
import UidLink from "./pages/UidLink";
import MoveToWebUsingBySyncId from "./pages/UidLink/MoveToWebUsingBySyncId";

export const stores = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }),
  // .concat(middlewares), //미들웨어 적용
  devTools: process.env.NODE_ENV !== "production",
});

function App() {
  const [loading, changeLoading] = useState(false);
  useEffect(() => {
    if (window.navigator.language === "ar") {
      document.documentElement.setAttribute("lang", "ar");
      document.documentElement.setAttribute("dir", "rtl");
    } else if (["ko", "ko-KR", "ko-kr"].includes(window.navigator.language)) {
      document.documentElement.setAttribute("lang", "ko");
      document.documentElement.setAttribute("dir", "ltr");
    } else {
      document.documentElement.setAttribute("lang", "en");
      document.documentElement.setAttribute("dir", "ltr");
    }
    if (window.eco.isCspp) {
      initMSAppConfig();
    }
  }, []);
  return (
    <ToastProvider
      isCentered
      isClient={
        utilsCommon.isClientLogin("WINDOWS") || utilsCommon.isClientLogin("MAC")
      }
    >
      <BrowserRouter>
        <Provider store={stores}>
          <ProgressParents isOn={loading} />
          <Suspense fallback={null}>
            <Routes>
              <Route
                path={`${process.env.PUBLIC_URL}/login`}
                element={<Login changeLoading={changeLoading} />}
              />
              <Route
                path={`${process.env.PUBLIC_URL}/checkSignup`}
                element={<CheckSignup />}
              />
              <Route
                path={`${process.env.PUBLIC_URL}/signup`}
                element={<Signup />}
              />
              <Route
                path={`${process.env.PUBLIC_URL}/service`}
                element={<Service />}
              />
              <Route
                path={`${process.env.PUBLIC_URL}/docs/preview`}
                element={<Preview />}
              />
              <Route
                path={`${process.env.PUBLIC_URL}/admin/login`}
                element={<Login isAdmin={true} changeLoading={changeLoading} />}
              />
              <Route
                path={`${process.env.PUBLIC_URL}/wsPrivacy`}
                element={<TermsPage />}
              />
              <Route
                path={`${process.env.PUBLIC_URL}/wsTerms`}
                element={<PrivacyPage />}
              />
              <Route
                path={`${process.env.PUBLIC_URL}/admin/*`}
                element={<BaseLayoutAdmin />}
              />
              <Route
                path={`${process.env.PUBLIC_URL}/error`}
                element={<ErrorPage />}
              />
              <Route
                path={`${process.env.PUBLIC_URL}/client/download`}
                element={
                  <MoveToWebUsingBySyncId changeLoading={changeLoading} />
                }
              />
              <Route
                path={`${process.env.PUBLIC_URL}/action/byuid/:uid`}
                element={<UidLink changeLoading={changeLoading} />}
              />
              <Route
                path={`${process.env.PUBLIC_URL}/client/docDetail/:syncId`}
                element={<ClientDocDetailModal />}
              />
              <Route
                path={`${process.env.PUBLIC_URL}/client/none`}
                element={<ClientNone />}
              />
              <Route
                path={`${process.env.PUBLIC_URL}/client/*`}
                element={<ClientEco />}
              />
              <Route
                path={`${process.env.PUBLIC_URL}/downloadClient`}
                element={<DownloadClient changeLoading={changeLoading} />}
              />
              <Route
                path={`${process.env.PUBLIC_URL}/api-reference`}
                element={<ApiReference />}
              />
              <Route
                path={`${process.env.PUBLIC_URL}/*`}
                element={<BaseLayout />}
              />
              <Route
                path={`${process.env.PUBLIC_URL}/linkLogin`}
                element={<LinkLogin changeLoading={changeLoading} />}
              />
            </Routes>
          </Suspense>
        </Provider>
      </BrowserRouter>
    </ToastProvider>
  );
}

export default App;
